const defaultUsername = 'User';

export default ({ firstName, lastName, email } = {}) => {
  if (
    typeof firstName !== 'string' &&
    typeof lastName !== 'string' &&
    typeof email !== 'string'
  )
    return defaultUsername;

  const combinedName =
    `${firstName?.trim() ?? ''} ${lastName?.trim() ?? ''}`?.trim() ?? '';

  if (combinedName.length) return combinedName;

  if (email.length) return email.trim();

  return defaultUsername;
};
